import { StatusCodes } from "http-status-codes"
import ResponseError from "#/types/responseError"
import { GuideSurveyAnswers } from "../types/GuideSurveyAnswers"
import { v4 as uuid } from "uuid"

export default class GuidesClient {
  baseUrl: string

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  async ProcessJsonResponse<T>(response: any, correlationId: any): Promise<T> {
    if (response.status === StatusCodes.OK) {
      const responseText = await response.text()
      return responseText ? JSON.parse(responseText) : null
    }
    throw new ResponseError(response, correlationId)
  }

  createJsonHeaders(correlationId: any): Headers {
    const headers = new Headers()
    headers.append("X-Request-ID", correlationId)
    headers.append("X-React-App-Version", __APP_VERSION__ || "local")
    headers.append("Content-Type", "application/json")
    return headers
  }

  async getCountByGuideEmployee(guideId: any): Promise<number> {
    const correlationId = uuid()

    const response = await fetch(`${this.baseUrl}/api/v2/guides/${guideId}/users/me/survey-answers/count`, {
      method: "GET",
      headers: this.createJsonHeaders(correlationId),
      credentials: "include"
    })

    return response.json()
  }

  async submitGuideSurveyAnswers({ guideId, ...answers }: GuideSurveyAnswers): Promise<void> {
    const correlationId = uuid()
    const headers = new Headers()
    headers.append("X-Request-ID", correlationId)
    headers.append("X-React-App-Version", __APP_VERSION__ || "local")
    headers.append("Content-Type", "application/json")

    const body = JSON.stringify({
      ...answers
    })
    await fetch(`${this.baseUrl}/api/v2/guides/${guideId}/users/me/survey-answers`, {
      credentials: "include",
      body,
      headers,
      method: "POST"
    })
  }
}
